import { CrmReceiverCustomer } from '@/components/CRM/ShippingOptions/ShippingOptionsCustomerTable';
import { PageRequest } from '@/core/request/PageRequest';
import { AccountReceivableSituation } from '../../financial/AccountReceivable/AccountReceivable.types';
import { Moment } from 'moment';

export interface CrmCustomerBirthdaysRequest extends PageRequest {
  initialDate?: string;
  finalDate?: string;
  name?: string;
}

export interface CrmCustomerListResponse {
  id: number;
  name: string;
  email: string;
  birthDate: string;
  lastSentEmail: string;
}

export interface CrmSurveySatisfaction {
  customer: CrmSurveySatisfactionCustomer;
  complement: CrmSurveySatisfactionComplement;
  vehicle: CrmSurveySatisfactionVehicle;
}

export interface CrmSurveySatisfactionCustomer {
  id: number;
  name: string;
  email: string;
  birthDate: Moment;
  lastSentEmail: Moment;
}
export interface CrmSurveySatisfactionComplement {
  id: number;
  complementNumber: number;
  workOrderNumber: number;
  number: string;
}

export interface CrmSurveySatisfactionVehicle {
  id: number;
  brand: string;
  licensePlate: string;
  model: string;
}

export interface CrmCustomerDebitsListResponse {
  id: number;
  code: string;
  situation: AccountReceivableSituation;
  dueDate: string;
  customer: CrmCustomerListResponse;
}

export interface CrmCustomerWithVehicleListResponse {
  id: number;
  licensePlate: string;
  model: string;
  brand: string;
  customer: CrmCustomerListResponse;
}

export interface CrmFutureService {
  id: number;
  date: string;
  description: string;
}

export interface CrmCustomerFutureServiceListResponse {
  vehicleId: number;
  licensePlate: string;
  model: string;
  brand: string;
  customer: CrmCustomerListResponse;
  futureServices: CrmFutureService[];
}

export enum RevisionItemType {
  Part = 'domain.enums.work_order_item_type.part',
  Service = 'domain.enums.work_order_item_type.service',
}

export enum CrmCustomerGender {
  Woman = 'domain.enums.customer_gender.woman',
  Man = 'omain.enums.customer_gender.man',
}

export interface CrmCustomerCustomRequest extends PageRequest {
  brandId?: number;
  modelId?: number;
  gender?: CrmCustomerGender;
  name?: string;
  startDate?: string;
  endDate?: string;
}

export interface CrmCustomerFutureServicesRequest extends PageRequest {
  brandId?: number;
  modelId?: number;
  gender?: CrmCustomerGender;
  name?: string;
  initialDate?: string;
  finalDate?: string;
}

export interface CrmCustomerBaseRequest extends PageRequest {
  name?: string;
}

export interface CrmCustomerWithMovimentRequest extends PageRequest {
  name?: string;
  initialDate?: string;
  finalDate?: string;
}

export interface CrmCustomerRecoveryDebtsRequest extends PageRequest {
  name?: string;
  companyId?: number;
  dueDateInitial?: string;
  dueDateFinal?: string;
}

export interface CrmCustomerListProps {
  onPrev(): void;
  CustomersSelected: CrmReceiverCustomer[];
  onCustomersSelected: React.Dispatch<
    React.SetStateAction<CrmReceiverCustomer[]>
  >;
  customerIds: number[];
}

export interface RevisionItem {
  id: number;
  name: string;
  revisionDateKm: string;
  revisionDateLifespan: string;
  type?: RevisionItemType;
}

export type CrmCustomerPart = RevisionItem;
export type CrmCustomerServices = RevisionItem;

export interface CrmCustomerNextRevision {
  id: number;
  licensePlate: string;
  model: string;
  brand: string;
  customer: CrmCustomerListResponse;
  parts: CrmCustomerPart[];
  services: CrmCustomerServices[];
}
